// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_8-1";
export var movingGradient = "_8-4";
export var movingGradientBlock = "_8-2";
export var skeleton = "_8-0";
export var skeletonText = "_8-3";